// ---------------------------------------------------------------------------
// Fuente de reseñas para el frontend.
//
// TEMPORAL: hoy lee el export de WooCommerce (woo-reviews-export.json, 1090
// reseñas reales recuperadas de WordPress). Cuando el módulo `product-review`
// de Medusa esté en línea, este helper se cambia por una llamada a
// `GET /store/products/:id/reviews` y el componente no necesita tocarse.
//
// El export trae `pid` (id de producto en WordPress) y `product` (nombre en WP),
// no el handle de Medusa. Mapeamos por nombre normalizado; si algún producto no
// casa por nombre, se puede forzar con HANDLE_TO_PID abajo.
// ---------------------------------------------------------------------------
import rawReviews from './woo-reviews-export.json';

// Normaliza un texto para comparar nombres de producto entre WP y Medusa:
// minúsculas, sin acentos, sin signos, espacios colapsados.
const norm = (s = '') =>
  s
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

// Override manual handle(Medusa) -> pid(WordPress) para casos que no casan por
// nombre. Ej: 'serum-12-vitamina-c-pura': 1068
const HANDLE_TO_PID = {};

// Agrupa las reseñas por pid una sola vez (al importar el módulo).
const byPid = new Map();
const byNormName = new Map();
for (const r of rawReviews) {
  if (!byPid.has(r.pid)) byPid.set(r.pid, []);
  byPid.get(r.pid).push(r);
  const key = norm(r.product);
  if (key && !byNormName.has(key)) byNormName.set(key, r.pid);
}

// Calcula promedio + distribución 1..5 de un set de reseñas.
export function summarize(reviews) {
  const distribution = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
  let sum = 0;
  for (const r of reviews) {
    const n = Math.round(r.rating);
    if (distribution[n] != null) distribution[n] += 1;
    sum += r.rating;
  }
  const count = reviews.length;
  return {
    count,
    average: count ? sum / count : 0,
    distribution,
  };
}

// Resuelve el pid de un producto de Medusa a partir de {handle, title}.
function resolvePid({ handle, title } = {}) {
  if (handle && HANDLE_TO_PID[handle] != null) return HANDLE_TO_PID[handle];
  if (title) {
    const key = norm(title);
    if (byNormName.has(key)) return byNormName.get(key);
    // match laxo: el nombre WP contiene el título Medusa o viceversa
    for (const [name, pid] of byNormName) {
      if (name.includes(key) || key.includes(name)) return pid;
    }
  }
  return null;
}

// API pública del helper: devuelve { reviews, summary } para un producto.
export function getProductReviews(product) {
  const pid = resolvePid(product || {});
  const reviews = pid != null ? byPid.get(pid) || [] : [];
  return { reviews, summary: summarize(reviews) };
}

export default getProductReviews;
